import { Fragment } from "react";
import { Outlet } from "react-router";

export default function Account() {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
}
